/**
 * Takes multiple fields, and makes them readonly.
 * @param {String} params.field - This field's data you want to make readonly
 */
export const makeReadonly = function (params: any, schema: any, uiSchema: any, formData: any) {

  var fields = params.field || [];

  if (Array.isArray(params.field) && params.field.length) {
    fields.forEach((field: string) => {
      uiSchema[field] = {
        ...(uiSchema[field] || {}),
        "ui:readonly": true
      }
    })
  } else if (params.field) {
    uiSchema[params.field] = {
      ...(uiSchema[params.field] || {}),
      "ui:readonly": true
    }
  }
};


// Action validation
if (process.env.NODE_ENV !== 'production') {

  const PropTypes = require('prop-types');

  makeReadonly.propTypes = {
    field: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
  };

  makeReadonly.validate = function ({ field }: any, schema: any, uiSchema: any) {
    if (Array.isArray(field)) {
      field
        .filter(f => schema && schema.properties && schema.properties[f] === undefined)
        .forEach(f => console.error(`Field  "${f}" is missing from schema on "require"`));
    } else if (
      schema &&
      schema.properties &&
      schema.properties[field] === undefined
    ) {
      console.error(`Field  "${field}" is missing from schema on "require"`);
    }
  };

}